import { MotionStyle } from 'framer-motion'

export const slideStyle: MotionStyle = {
  position: 'relative',
  marginBottom: 30
}
